<template>
  <div v-if="items.length" class="finder-landing-featured-navigation doctor-finder-landing-content">
    <header v-if="navigation.title" class="doctor-finder-landing-title">
      <h3 class="section-title">{{ navigation.title }}</h3>
    </header>
    <div class="doctor-finder-landing-specialties">
      <sp-finder-specialty-grid>
        <sp-tile-group>
          <sp-tile
            v-for="(item, index) in items"
            :key="index"
            :data-testid="TestId.finder.landingFeaturedOption"
            :label="item.name"
            :icon="item.icon"
            :icon-background-color="item.iconBackgroundColor"
            class="doctor-finder-landing-specialty"
            role="button"
            tabindex="0"
            @click="handleSearch(item)"
            @keyup.enter.stop.prevent="handleSearch(item)"
            @keydown.space.stop.prevent="handleSearch(item)"
          >
            <div slot="content">
              <div class="doctor-finder-landing-specialty-text">
                <p v-if="item.description">{{ item.description }}</p>
              </div>
              <span
                v-if="navigation.item_config?.show_read_more"
                aria-hidden="true"
                class="doctor-finder-landing-specialty-link"
              ></span>
            </div>
          </sp-tile>
        </sp-tile-group>
      </sp-finder-specialty-grid>
    </div>
    <div v-if="navigation.show_more_button" class="doctor-finder-landing-specialty-more">
      <sp-button
        :data-testid="TestId.finder.landingFeaturedMore"
        variant="outlined"
        block-sm
        @click="handleFocusSearch"
      >
        {{ navigation.show_more_button_text }}
      </sp-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";

const props = defineProps({
  navigation: { type: Object, required: true },
});
const emit = defineEmits(["search", "focus-search"]);

const items = computed(() => {
  const config = props.navigation.item_config;
  return (props.navigation.items ?? []).map((value) => {
    const item = typeof value === "string" ? JSON.parse(value) : value;
    const result = { ...item };
    if (config?.show_icon) {
      result.icon = `${item.icon_name || "specialty"}-${config.icon_variant}`;
      if (config.icon_variant === "filled") {
        result.iconBackgroundColor =
          item.icon_background_color || "var(--sp-comp-finder-specialty-grid-icon-bg-default, #8ccde6)";
      }
    }
    return result;
  });
});

function handleSearch(item) {
  emit("search", { ...item.url_params });
}

function handleFocusSearch() {
  emit("focus-search");
}
</script>
